export default __webpack_public_path__ + "static/media/splendidGroup.9920ac88.JPG";